import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=d8bd3c26&scoped=true&isFirst=true&page=true"
import script from "./index.mpx?vue&type=script&lang=js&isFirst=true&page=true"
export * from "./index.mpx?vue&type=script&lang=js&isFirst=true&page=true"
import style0 from "./index.mpx?vue&type=style&index=0&id=d8bd3c26&scoped=true&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22mb155b2e0%22%7D&isFirst=true&page=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bd3c26",
  null
  
)

export default component.exports